module.exports = __webpack_public_path__ + "img/LR.3a9dbe4c.png";